export default "__VITE_ASSET__b3e6d031__"